import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Courses.css";
// import Services from "../pages/services";

const apiKey = "AIzaSyAWcEkIYuIgpIOwgDi4lS3eBX0Ykp8B1_A"; // Replace with your YouTube Data API key
const channelId = "UCIEy6MlPqCr2KoaJi332VZg";

const Courses = () => {
  const [playlists, setPlaylists] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  useEffect(() => {
    fetchPlaylists();
  }, []);

  const fetchPlaylists = async () => {
    try {
      const response = await fetch(
        `https://www.googleapis.com/youtube/v3/playlists?key=${apiKey}&channelId=${channelId}&part=snippet&maxResults=20`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch playlists");
      }

      const data = await response.json();
      if (data.error) {
        throw new Error(data.error.message);
      }
      setPlaylists(data.items);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching playlists:", error);
      setError("Failed to fetch playlists. Please try again later.");
      setLoading(false);
    }
  };

  const openModal = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  const renderVideos = () => {
    if (loading) {
      return <p>Loading playlists...</p>;
    }

    if (error) {
      return <p>{error}</p>;
    }

    return (
      <ul className="playlist-list">
        {playlists.length > 0 ? (
          playlists.map((playlist) => (
            <li key={playlist.id} className="playlist-item" data-aos="fade-up">
              <h3 className="playlist-title">{playlist.snippet.title}</h3>
              <div className="video-thumbnail">
                <img
                  src={playlist.snippet.thumbnails.high.url}
                  alt={playlist.snippet.title}
                  onClick={() => openModal(playlist)}
                />
                <div className="play-icon">▶</div>
              </div>
            </li>
          ))
        ) : (
          <p>No playlists found.</p>
        )}
      </ul>
    );
  };

  return (
    <div className="courses-container">
      <h1 className="courses-heading">Courses</h1>
      {renderVideos()}

      {/* Modal for displaying selected video */}
      {selectedVideo && (
        <div className="modal" data-aos="zoom-in">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              ×
            </span>
            <iframe
              title={selectedVideo.snippet.title}
              className="video-iframe"
              src={`https://www.youtube.com/embed/videoseries?list=${selectedVideo.id}`}
              frameBorder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
            <h2 className="video-title">{selectedVideo.snippet.title}</h2>
          </div>
        </div>
      )}
      {/* <Services /> */}
    </div>
  );
};

export default Courses;
